// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mY-0DPhN>*+*{margin-top:max(3rem,min(4.17vw,5rem))}.zcQaxoZ6{font-size:max(2rem,min(3.13vw,3.75rem))}.S5kqgJTs{color:#32388c;-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "mY-0DPhN",
	"heading": "zcQaxoZ6",
	"logoLink": "S5kqgJTs"
};
module.exports = ___CSS_LOADER_EXPORT___;
